import React from 'react'
import PropTypes from 'prop-types'
import { Timeline, ButtonIcon } from '../../../components'
import { getMonthString, CREATE_BOOKING } from '../../../helpers'
import { DAY_VIEW } from '../../../helpers/constants'
import Style from './style'

const oneDayTimeStamp = 1000 * 60 * 60 * 24
const timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000

class RoomTimeline extends React.Component {
  getStartDateTimestamp (currentTimestamp) {
    return Math.floor(currentTimestamp / oneDayTimeStamp) * oneDayTimeStamp
  }

  render () {
    const {
      className,
      bookingList,
      selectedDate,
      roomName,
      handleClickTimeline,
      handleClose,
      handleMoveTimeline,
      language,
      minuteStep,
      startOperatingTime,
      endOperatingTime,
      colorTheme,
      startDatetimeHeader,
      endDatetimeHeader,
    } = this.props
    const today = new Date(this.getStartDateTimestamp(selectedDate.valueOf() - timezoneOffset))

    return (
      <Style
        className={className}
        colorTheme={colorTheme}
      >
        <section className='room-header'>
          <h4 className='room-name-text'>
            {roomName ? roomName.name : ''}
          </h4>
          <p className='room-name-subtext'>
            {CREATE_BOOKING.CALENDAR[language]}
          </p>
        </section>
        <Timeline
          bookingList={bookingList}
          startDatetimeContent={today}
          endDatetimeContent={today}
          handleClickTimeline={handleClickTimeline}
          handleEdit={handleMoveTimeline}
          minuteStep={minuteStep}
          startOperatingTime={startOperatingTime}
          endOperatingTime={endOperatingTime}
          language={language}
          headerType={DAY_VIEW.HEADER_TYPE.MINI}
          headerTextMonth={`${getMonthString(today, language).toUpperCase()} ${today.getFullYear()}`}
          colorTheme={colorTheme}
          startDatetimeHeader={startDatetimeHeader}
          endDatetimeHeader={endDatetimeHeader}
        />
        <ButtonIcon
          icon='close.svg'
          onClick={handleClose}
          className='close-btn'
        />
      </Style>
    )
  }
}

RoomTimeline.propTypes = {
  bookingList: PropTypes.array,
  className: PropTypes.string,
  colorTheme: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  minuteStep: PropTypes.number,
  startOperatingTime: PropTypes.string,
  endOperatingTime: PropTypes.string,
  startDatetimeHeader: PropTypes.instanceOf(Date),
  endDatetimeHeader: PropTypes.instanceOf(Date),
}

export default RoomTimeline
